module.exports = __webpack_public_path__ + "media/images/shark/Leona_1-p-800-140176fe74e1ff0d5d2ebf24403fc9fb.jpeg";